import { ProductId } from '../../product-selector';
import {
    Action, ActionWithoutPayload
} from '../../types/common.types';

export enum DynamicParams {
    combinedAssignAndReviewDefaultTab = 'combinedAssignAndReviewDefaultTab'
}

export type AppDynamicParams = {
    [id: string]: any
};

export type ApplicationState = {
    isInitialized: boolean
    localeLoaded: string | null
    userHasProductAccess: boolean
    currentProductId: ProductId | number
    currentClassroom: CurrentClassroom | null
    appLoading: LoadingState
    dynamicParams: AppDynamicParams
};

export const UPDATE_SELECTED_CLASSROOM = 'UPDATE_SELECTED_CLASSROOM';

export type CurrentClassroom = {
    classId: string
    // groups optional
    // @see https://bitbucket.org/mathletics/mathletics-portal-communication-service/src/ee3c42c4bee753ad9661870832dad6f3489675bd/index.ts#lines-16
    groupId?: string
    sourceModuleId?: string
};

export type SelectedClassroomAction = {
    type: typeof UPDATE_SELECTED_CLASSROOM
    payload: CurrentClassroom | null
};

export const APP_INITIALIZED = 'APP_INITIALIZED';

export type InitializeAppAction = Action<typeof APP_INITIALIZED, {
    isInitialized: boolean
    currentProductId: ProductId | number
}>;

export const UPDATE_PRODUCT_ACCESS = 'UPDATE_PRODUCT_ACCESS';

export type ProductAccessAction = Action<typeof UPDATE_PRODUCT_ACCESS,
    { hasAccess: boolean }>;

export const UPDATE_SELECTED_PRODUCT = 'UPDATE_SELECTED_PRODUCT';

export type UpdateSelectedProductAction = Action<typeof UPDATE_SELECTED_PRODUCT,
    { productId: number }>;

export const APP_CLEAR = 'APP_CLEAR';

export type ClearAppAction = ActionWithoutPayload<typeof APP_CLEAR>;

export const UPDATE_APP_LOCALE = 'UPDATE_APP_LOCALE';

export type UpdateAppLocale = Action<typeof UPDATE_APP_LOCALE, {
    localeLoaded: string | null
}>;

export const SET_LOADING = 'SET_LOADING';

export type SetAppLoadingAction = {
    type: typeof SET_LOADING
    payload: LoadingState
};

export const SET_APP_DYNAMIC_PARAMS = 'SET_APP_DYNAMIC_PARAMS';

export type SetAppDynamicParams = {
    type: typeof SET_APP_DYNAMIC_PARAMS
    payload: AppDynamicParams
};

export enum ProductIds {
    mathletics = 1,
    readiwriterSpelling = 10,
    readiwriterWriting = 11
}

export enum LoadingState {
    loaded,
    appLoading,
    contentLoading
}

export type AppActions =
    | SelectedClassroomAction
    | UpdateAppLocale
    | InitializeAppAction
    | ProductAccessAction
    | UpdateSelectedProductAction
    | ClearAppAction
    | SetAppLoadingAction
    | SetAppDynamicParams;
